import { render } from "./CreateUpdateFir.vue?vue&type=template&id=dad9b200"
import script from "./CreateUpdateFir.vue?vue&type=script&lang=js"
export * from "./CreateUpdateFir.vue?vue&type=script&lang=js"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__